import { OrderRejectionReason } from '../../../../../services/exports/Constants';

export default {
  header: 'Anulează comanda',
  title: 'Nu respinge niciodată prea ușor!',
  text: 'Dacă există o problemă minoră cu comanda, sunați clientul și rezolvați-o.',
  reasons: {
    [OrderRejectionReason.ItemUnavailable]: 'Articole indisponibile',
    [OrderRejectionReason.ClosingSoon]: 'Magazinul este închis',
    [OrderRejectionReason.StoryBusy]: 'Magazinul este prea aglomerat',
    [OrderRejectionReason.CustomerMistake]: 'Clientul a sunat să anuleze',
    [OrderRejectionReason.DriverNotArrived]: 'Șoferul nu a sosit',
  },
  buttons: {
    confirm: 'Confirmă',
  },
};
